import React, { useState } from 'react';
import Styles from './Switch.module.scss';
import { C } from 'shared/helpers';
import PropTypes from 'prop-types';

/**
 * @param {{
 *  onText: any,
 *  offText: any,
 *  active: boolean,
 *  disabled: boolean,
 *  onChange: (state: boolean) => void,
 *  className: any
 * }} props
 */
export default function Switch(props) {
  const { className, active, onChange, onText, offText, disabled } = props;
  const [innerActive, setInnerActive] = useState(active || false);

  function toggleActive() {
    setInnerActive(!innerActive);
    onChange(!innerActive);
  }

  // If the active prop is not informed, uses the inner state
  const isActive = (active === undefined) ? innerActive : active;

  return (
    <div
      className={C(
        className,
        Styles.Switch,
        [isActive, Styles.Active],
        [disabled, Styles.Disabled],
      )}
      onClick={!disabled ? toggleActive : undefined}
    >
      <div className={Styles.OnState}>{onText}</div>
      <div className={Styles.OffState}>{offText}</div>
    </div>
  );
}

Switch.propTypes = {
  onText: PropTypes.any,
  offText: PropTypes.any,
  onChange: PropTypes.func,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.any,
};

Switch.defaultProps = {
  onText: 'On',
  offText: 'Off',
  onChange: console.log,
  active: undefined,
  disabled: false,
  className: '',
};
